@if (translationsReady) {
  <div class="container-fluid p-3">
    <span class="m-0 subheadText">{{ title | translate }}</span>
    <div class="mt-3">
      <div id="divBarChart"></div>
      @if (noDataOnChart) {
        <p>{{ 'STATISTICS.NO_CHART_DATA' | translate }}</p>
      }
    </div>
  </div>
}
